module.exports = __webpack_public_path__ + "static/media/globe@3x.98532018.png";